import { render } from "./OrganParts.vue?vue&type=template&id=25015657&scoped=true&lang=html"
import script from "./OrganParts.vue?vue&type=script&lang=js"
export * from "./OrganParts.vue?vue&type=script&lang=js"

import "./OrganParts.vue?vue&type=style&index=0&id=25015657&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25015657"]])

export default __exports__